import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { CheckboxIcon as Checkbox, CheckboxCheckedIcon } from '@wf-sl/common-icons'

import styles from './checkbox.module.css'

const propTypes = {
    checked: PropTypes.bool,
    iconCheckedClassName: PropTypes.string,
    iconUncheckedClassName: PropTypes.string,
    width: PropTypes.number
}

const defaultProps = {
    checked: false,
    width: 16
}

/**
 * Simple component to handle checkbox icons. Privately
 * used by Checkbox.
 *
 * @private
 * @param {boolean} [props.checked=false] - The current checkbox checked state
 * @param {string} [props.iconCheckedClassName] - Additional className for the unchecked icon component
 * @param {string} [props.iconUncheckedClassName] - Additional className for the unchecked icon component
 * @param {number} [props.width=16] - The icon width
 * @returns {ReactElement}
 */
function CheckboxIcon(props) {
    const { checked, iconCheckedClassName, iconUncheckedClassName, width } = props

    const classNameIconUnchecked = cx(styles['checkbox-icon'], iconUncheckedClassName, 't3sel-checkbox-icon')
    const classNameIconChecked = cx(
        styles['checkbox-icon'],
        styles['checkbox-icon-checked'],
        iconCheckedClassName,
        't3sel-checkbox-icon-checked'
    )

    return checked ? (
        <CheckboxCheckedIcon data-testid="checkbox-icon-checked" className={classNameIconChecked} width={width} />
    ) : (
        <Checkbox data-testid="checkbox-icon" className={classNameIconUnchecked} width={width} />
    )
}

CheckboxIcon.propTypes = propTypes
CheckboxIcon.defaultProps = defaultProps

export { CheckboxIcon }
